{
  "name": "@formbrew/embed",
  "version": "0.4.0",
  "description": "Hosted, framework-free Formbrew form embed for browser websites.",
  "keywords": [
    "forms",
    "formbrew",
    "embed"
  ],
  "type": "module",
  "license": "MIT",
  "sideEffects": [
    "./dist/embed.js",
    "./dist/styles.css"
  ],
  "files": [
    "dist",
    "LICENSE",
    "README.md"
  ],
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js"
    },
    "./embed.js": "./dist/embed.js",
    "./global": {
      "types": "./dist/global.d.ts"
    },
    "./styles.css": "./dist/styles.css",
    "./package.json": "./package.json"
  },
  "jsdelivr": "./dist/embed.js",
  "unpkg": "./dist/embed.js",
  "style": "./dist/styles.css",
  "engines": {
    "node": ">=20"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/solspace/formbrew.git",
    "directory": "packages/embed"
  },
  "homepage": "https://github.com/solspace/formbrew#readme",
  "bugs": {
    "url": "https://github.com/solspace/formbrew/issues"
  },
  "publishConfig": {
    "access": "public"
  },
  "scripts": {
    "build": "tsup && cp src/global.d.ts dist/global.d.ts && bun run scripts/build-styles.ts",
    "pack:check": "bun run build && tsc --noEmit -p tsconfig.consumer.json && bun run scripts/check-package.ts && npm pack --dry-run",
    "typecheck": "tsc --noEmit -p tsconfig.json"
  },
  "devDependencies": {
    "@formbrew/js": "0.4.0",
    "happy-dom": "^20.10.6",
    "tsup": "^8.5.1"
  }
}
